import { BaseModel } from './base-model';
import { ZoneFeature } from './zones-base-interfaces';

export abstract class PrecautionaryZonesModelBase extends BaseModel
{
    abstract getPrecautionaryZones(): Promise<ZoneFeature[] | null>;
}

let PrecautionaryZonesModel: PrecautionaryZonesModelBase|null = null;

function setPrecautionaryZonesModel(model: PrecautionaryZonesModelBase)
{
    PrecautionaryZonesModel = model;
}

export { PrecautionaryZonesModel, setPrecautionaryZonesModel };
